import { paymentStatuses } from 'utils/paymentStatuses';

type OrderStatus = 'pending' | 'paid' | 'retired';

export function getOrderStatus(order: Order): OrderStatus {
  let orderStatus: OrderStatus = 'pending';
  if (order.supplyStatus === 'Retired') {
    orderStatus = 'retired';
  } else if (order.payment.status === paymentStatuses.paid) {
    orderStatus = 'paid';
  }

  return orderStatus;
}
